<template>
  <v-dialog
          transition="dialog-top-transition"
          max-width="1160"
          v-model="show"
  >
    <template v-slot:default="dialog">
      <div class="visa-approved-modal">

        <h2 class="modal-title">VISA <br/>APPROVED</h2>

        <div class="content" v-if="info">
          <div class="line level-1">
            <div class="block">
              <p class="label">Client Name</p>
              <p class="value">{{info.full_name}}</p>
            </div>
          </div>
          <div class="line level-2">
            <div class="block">
              <p class="label">Account Number</p>
              <p class="value">{{info.acc_number}}</p>
            </div>
          </div>
          <div class="line level-3">
            <div class="block">
              <p class="label">Visa Status</p>
              <p class="value">{{info.visa_status}}</p>
            </div>
            <div class="block">
              <p class="label">Visa Type</p>
              <p class="value">{{info.visa_type}}</p>
            </div>
          </div>
          <div class="line level-4">
            <div class="block">
              <p class="label">Retention Agent</p>
              <p class="value">{{info.retention_agent}}</p>
            </div>
            <div class="block">
              <p class="label">Conversion Agent</p>
              <p class="value">{{info.agent}}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </v-dialog>
</template>

<script>
    export default {
        name: "VisaApproved",
        props: ["data"],
        data() {
            return {
                info: null,
                show: false,
            };
        },
        methods: {
            open(data) {
                this.info = data;
                this.show = true;
                setTimeout(() => {
                    this.show = false
                }, 7000);
            },
        },
    };
</script>

<style lang="scss">
  .visa-approved-modal{
    position: relative;
    background-image: url("https://s3.amazonaws.com/canadian-visa-media/agent-sales/visa-approved-bg.png");
    background-position: 50% 50%;
    background-size: cover;
    height: 700px;

    .modal-title{
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      transform: translate(0px, -140px);

      font-weight: 500;
      font-size: 50px;
      line-height: 113.5%;
      text-align: center;
      letter-spacing: 0.07em;
      color: #D0D0D0;
    }

    .content{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background-image: url("https://s3.amazonaws.com/canadian-visa-media/agent-sales/Polygon.png");
      background-position: 50% 50%;
      background-size: cover;
      padding: 15px;

      .line{
        padding: 20px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 0 auto;
        &:not(:last-child){
          border-bottom: 1px solid #29214B;
        }

        &.level-1{
          max-width: 200px;
        }
        &.level-2{
          max-width: 475px;
        }
        &.level-3{
          max-width: 760px;
        }
        &.level-4{
          max-width: 760px;
        }

        .block{
          text-align: center;
          flex: 1 1 100%;
          &:not(:first-child){
            border-left: 1px solid #342E6C;
          }

          .label{
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            color: #4E5275;
            text-transform: capitalize;
            margin-bottom: 5px;
          }

          .value{
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
            color: #D0D0D0;
            margin: 0;
            text-transform: uppercase;
          }
        }
      }
    }
  }
</style>
